export default "__VITE_ASSET__Cts_xXDN__"